export default __webpack_public_path__ + "static/center-img-27da7e6d4c1f0a7a172d60a264b4850d.jpg";